import { SettingOutlined } from '@ant-design/icons';
import { Button, ButtonProps, Popover } from 'antd';
import * as React from 'react';
import { useWatch } from 'react-hook-form';
import { IReference } from '../../../references/IReference';
import { useAsyncServiceEngineContext } from '../context/AsyncServicesEngineContext';
import { AsyncExpressionOptionsInput } from './AsyncExpressionOptionsInput';
import { AsyncServiceSelectInput } from './AsyncServiceSelectInput';

export interface IAsyncExpressionInputProps {
  name: string;
  references: IReference[];

  size?: ButtonProps['size'];

  disabled?: boolean;
}

/**
 * Permette di selezionare un servizio asincrono e di configurarne i parametri.
 */
export function AsyncExpressionInput(props: IAsyncExpressionInputProps) {
  const { name, references, size, disabled } = props;
  const asyncContext = useAsyncServiceEngineContext();

  const selectedId = useWatch({ name: `${name}.serviceId` });
  const selected = asyncContext.services.find(s => s.id === selectedId);

  return (
    <>
      <AsyncServiceSelectInput name={`${name}.serviceId`} disabled={disabled} />
      {selected && (
        <Popover
          trigger={['click']}
          content={
            <AsyncExpressionOptionsInput
              service={selected}
              size={size}
              name={name}
              references={references}
            />
          }
        >
          <Button size={size} icon={<SettingOutlined />}>
            Configura
          </Button>
        </Popover>
      )}
    </>
  );
}
